import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Libraries
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Components & Views
import App from './App';
import ForgotPassword from 'views/ForgotPassword/ForgotPassword';
import SetPassword from 'views/SetPassword/SetPassword';
import Unsubscribe from 'views/Unsubscribe/Unsubscribe';

import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                {/* Public routes */}
                <Route path="/forgotpassword" element={<ForgotPassword />}></Route>
                <Route path="/resetpassword" element={<SetPassword />}></Route>
                <Route path="/activateuser" element={<SetPassword />}></Route>
                <Route path="/unsubscribe" element={<Unsubscribe />}></Route>
                {/* Private routes */}
                <Route path="/*" element={<App />}></Route>
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
